import CircleSvg from '../assets/services/circle.svg';
import HalfCircle from '../assets/services/halfCircle.png';

const PageHeader = ({heading, text}: {heading: string, text: string}) => {
  return (
    <div className="page-header-f">
        <img src={CircleSvg} alt="img" ></img>
        <div className='page-header-f-content'>
          <p className='page-header-f-heading'>
            {heading}
          </p>
          <p className='page-header-f-text'>
            {text}
          </p>
        </div>
        <img src={HalfCircle} alt="img"></img>
      </div>

  )
}

export default PageHeader